import { IconNames } from 'ui/theme';
import { MenuItem } from 'ui/components/Menu';
import { ReportId } from 'services/reports';
import { FeatureAccessKey } from 'types/featureAccess';

export const createActionBarOptions = (
  onReportClick: (reportId: ReportId) => void,
  featureAccess: Record<FeatureAccessKey, boolean>
): MenuItem[] => {
  const reportSubItems = [
    {
      label: 'Inventory On Hand',
      onOptionClick: () => onReportClick(ReportId.Items),
      separateAfter: true,
    },
    {
      label: 'Cycle Count',
      onOptionClick: () => onReportClick(ReportId.CycleCount),
      separateAfter: true,
    },
    {
      label: 'Inventory Valuation Summary',
      onOptionClick: () => onReportClick(ReportId.InventoryValuation),
      separateAfter: !featureAccess.canAccessPurchasing,
    },
    ...(featureAccess.canAccessPurchasing
      ? [
          {
            label: 'Reorder',
            onOptionClick: () => onReportClick(ReportId.Reorder),
          },
        ]
      : []),
  ];

  return [
    {
      icon: IconNames.FBOReportSmall,
      label: 'Show Report',
      subItems: reportSubItems,
    },
  ];
};
